export default "__VITE_ASSET__ChXIFnuR__"